/**
 * Checks if the current time is between a date range.
 *
 * @param {string|Date} startDate
 * @param {string|Date} endDate
 */
export const isWithinRange = (startDate: string | Date, endDate: string | Date) => {
    if (!startDate || !endDate) return false

    const nowDate = new Date()
    const nowTime = nowDate.getTime()
    const sDate = new Date(startDate).getTime()
    const eDate = new Date(endDate).getTime()

    return nowTime >= sDate && nowTime <= eDate
}
